import React from 'react'
import { withIcon } from '../../withIcon'

function CaretLeftIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M14.6522 18.5793L14.6522 5.42024C14.6522 5.25505 14.5644 5.10438 14.4285 5.03629C14.2937 4.96933 14.1349 4.99611 14.024 5.10772L7.46701 11.6872C7.3082 11.8457 7.3082 12.1538 7.46701 12.3134L14.024 18.8918C14.1349 19.0034 14.2937 19.0313 14.4285 18.9632C14.5644 18.8962 14.6522 18.7456 14.6522 18.5793Z" fill={color}/>
    </svg>
  )
}

export default withIcon(CaretLeftIcon)
